const baseUrl = 'https://demoreward.deyga.in/api/';

export default baseUrl;
